import React, { useState, useEffect } from "react";
import "../CSS/Style.css";
import axios from "axios";
import Header from "./Header";

const Ticket = () => {
  const [ticket, setTicket] = useState({ 
    category: "", 
    subcategory: "", 
    query: "",
    flat:'',
    area:"",
    landmark:'',
    pincode:'',
    town:"",
    ac_brand:"",
    model_number:"",
    standCharge:"",
    fittingCharge:"",
    date_of_purchase:'',
    charges:0,
    user_name:"",
    user_phone:"",
    alternativeMobile:"",
    final_charge:0
  });
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const ticketsPerPage = 5;
  const [createloading, setcreateloading] = useState(false);

  const [services, setServices] = useState([]);
  const [selectedPrice, setSelectedPrice] = useState(null);

  // const [flat, setFlat] = useState("");
  // const [area, setArea] = useState("");
  // const [landmark, setLandmark] = useState("");
  // const [pincode, setPincode] = useState("");
  // const [town, setTown] = useState("");
  // const [ac_brand, setac_brand] = useState("");
  // const [model_number, setmodel_number] = useState("");
  // const [date_of_purchase, setdate_of_purchase] = useState("");


  
  const categories = {
    Service: ["Dry Service", "Zed Wash Service", "Chemical Wash Service"],
    Complaint: ["Water Leakage", "Error Code on Display", "Noise Issue", "No Cooling", "Bad Odor/Smell"],
  };

  useEffect(() => {
    validateUser();
    fetchServices();
  }, []);

  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setTicket({
      ...ticket,
      category,
      subcategory: category === "Installation" || category === "Reinstallation" ? "NA" : "",
    });

    // Fetch price based on category
    updateServicePrice(category, "NA");
  };

  const handleSubcategoryChange = (e) => {
    const subcategory = e.target.value;
    setTicket({ ...ticket, subcategory });
    updateServicePrice(ticket.category, subcategory);
  };

  const updateServicePrice = (category, subcategory) => {
    if (!category) {
      setSelectedPrice(null);
      setTicket((prevTicket) => ({ ...prevTicket, charges: 0 })); // Reset charges if no category
      return;
    }
  
    const selectedService = services.find(
      (service) =>
        service.service_name === category || service.service_name === subcategory
    );
  
    const serviceCharge = selectedService ? selectedService.service_charge : 0;
  
    // Update charges in ticket state
    setSelectedPrice(serviceCharge);
    setTicket((prevTicket) => ({ ...prevTicket, charges: serviceCharge,final_charge:serviceCharge }));
  };
  


  const fetchServices = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const response = await axios.get("https://api.mahirefrigeration.com/api/get_all_services", config);

      if (response.data.success) {
        setServices(response.data.services);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const validateUser = async () => {
    let storedToken = sessionStorage.getItem("token");
    let storedEmail = sessionStorage.getItem("email");

    if (!storedToken || !storedEmail) {
      window.location.href = "/signin";
    } else {
      const config = { headers: { Authorization: `Bearer ${storedToken}` } };
      try {
        const res = await axios.get("https://api.mahirefrigeration.com/api/validateToken", config);
        if (res.data === "User validation failed") {
          sessionStorage.clear();
          window.location.href = "/signin";
        } else {
          fetchTickets();
        }
      } catch (error) {
        console.error("Validation Error:", error);
      }
    }
  };

  const fetchTickets = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const response = await axios.get("https://api.mahirefrigeration.com/api/get_user_tickets", config);
  
      if (response.data.success && Array.isArray(response.data.tickets)) {
        setTickets(response.data.tickets.reverse()); // Reverse the order
      } else {
        setTickets([]); // Ensure tickets state is an empty array
        setMessage(response.data.message || "No tickets available.");
      }
    } catch (error) {
      setTickets([]); // Handle error case by setting an empty array
      setMessage("Failed to fetch tickets. Try again.");
    } finally {
      setLoading(false);
    }
  };
  

  const createTicket = async (e) => {
    e.preventDefault();
    if (!ticket.category || !ticket.subcategory || !ticket.query) {
      setMessage("All fields are required!");
      return;
    }
    setcreateloading(true);
    try {
      const token = sessionStorage.getItem("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const response = await axios.post("https://api.mahirefrigeration.com/api/create_ticket", ticket, config);

      if (response.data.success) {
        setMessage("Ticket created successfully!");
        setTicket({ category: "", subcategory: "", query: "",  flat:'',
        area:"",
        landmark:'',
        pincode:'',
        town:"",
        ac_brand:"",
        model_number:"",
        standCharge:"",
        fittingCharge:"",
        alternativeMobile:"",
        date_of_purchase:'',
        charges:0,
        user_name:"",
        user_phone:""
       });
        fetchTickets();
      } else {
        setMessage(response.data.message);
      }
    } catch (error) {
      setMessage("Failed to create ticket. Try again.");
    }
    finally {
      setcreateloading(false); 
    }
  };

  const lastIndex = currentPage * ticketsPerPage;
  const firstIndex = lastIndex - ticketsPerPage;
  const currentTickets = tickets.slice(firstIndex, lastIndex);

  return (
    <>
      <Header />
      <div className="first_sec_ran">
      <div className="container mt-5" style={{ display: "flex", gap: "20px", flexWrap: "wrap"}}>
        {/* Ticket Creation Box */}
        <div className="box" style={{ flex: "1", padding: "20px", background: "#fff", borderRadius: "8px", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)" }}>
          <h2 style={{color:"#62BD69"}}>Create a Ticket</h2>
          <form onSubmit={createTicket}>
          <select className="form__field" name="category" value={ticket.category} onChange={handleCategoryChange} required>
              <option value="">Select Category</option>
              <option value="Service">Service</option>
              <option value="Complaint">Complaint</option>
              <option value="Installation">Installation</option>
              <option value="Reinstallation">Reinstallation</option>
            </select>
            {ticket.category && ticket.category !== "Installation" && ticket.category !== "Reinstallation" && (
              <select className="form__field" name="subcategory" value={ticket.subcategory} onChange={handleSubcategoryChange} required>
                <option value="">Select Subcategory</option>
                {categories[ticket.category]?.map((sub, index) => (
                  <option key={index} value={sub}>{sub}</option>
                ))}
              </select>
            )}

            {selectedPrice !== null && <p>Price: ₹{selectedPrice}</p>}
            <input type="input" class="form__field" placeholder="Enter Customer Name" value={ticket.user_name} onChange={(e)=>setTicket({ ...ticket, user_name: e.target.value })} name="username" id='username' required />
            <input type="input" class="form__field" placeholder="Enter Customer Mobile" value={ticket.user_phone} onChange={(e)=>setTicket({ ...ticket, user_phone: e.target.value })} name="userphone" id='userphone' required />
            <input type="input" class="form__field" placeholder="Enter Alternative Mobile" value={ticket.alternativeMobile} onChange={(e)=>setTicket({ ...ticket, alternativeMobile: e.target.value })} name="alternativeMobile" id='alternativeMobile' required />
            <input type="input" class="form__field" placeholder="Enter Flat Number" value={ticket.flat} onChange={(e)=>setTicket({ ...ticket, flat: e.target.value })} name="flat" id='flat' required />
            <input type="input" class="form__field" placeholder="Enter Area" value={ticket.area} onChange={(e)=>setTicket({ ...ticket, area: e.target.value })} name="area" id='area' required />
            <input type="input" class="form__field" placeholder="Enter Landmark" value={ticket.landmark} onChange={(e)=>setTicket({ ...ticket, landmark: e.target.value })} name="landmark" id='landmark' required />
            <input type="input" class="form__field" placeholder="Enter Area Pincode" value={ticket.pincode} onChange={(e)=>setTicket({ ...ticket, pincode: e.target.value })} name="pincode" id='pincode' required />
            <input type="input" class="form__field" placeholder="Enter Town/City" value={ticket.town} onChange={(e)=>setTicket({ ...ticket, town: e.target.value })} name="town" id='town' required />
            <input type="input" class="form__field" placeholder="Enter AC Brand Name" value={ticket.ac_brand} onChange={(e)=>setTicket({ ...ticket, ac_brand: e.target.value })} name="ac_brand" id='ac_brand' required />
            <input type="input" class="form__field" placeholder="Enter Model Number" value={ticket.model_number} onChange={(e)=>setTicket({ ...ticket, model_number: e.target.value })} name="model_number" id='model_number' required />
            <input type="input" class="form__field" placeholder="Enter Stand Charge" value={ticket.standCharge} onChange={(e)=>setTicket({ ...ticket, standCharge: e.target.value })} name="standCharge" id='standCharge' required />
            <input type="input" class="form__field" placeholder="Enter Fitting Charge" value={ticket.fittingCharge} onChange={(e)=>setTicket({ ...ticket, fittingCharge: e.target.value })} name="fittingCharge" id='fittingCharge' required />
            <div className="date-container">
      <input
        type="date"
        className={`form__field ${ticket.date_of_purchase ? "has-value" : ""}`}
        value={ticket.date_of_purchase}
        onChange={(e) => {
          setTicket({ ...ticket, date_of_purchase: e.target.value });
        }}
        onFocus={(e) => e.target.classList.add("no-placeholder")}
        onBlur={(e) => {
          if (!e.target.value) {
            e.target.classList.remove("no-placeholder");
          }
        }}
        name="date_of_purchase"
        id="date_of_purchase"
        required
      />
      {!ticket.date_of_purchase && <span className="custom-placeholder">Enter date of purchase</span>}
    </div>



            <textarea className="form__field" name="query" placeholder="Describe your issue..." value={ticket.query} onChange={(e) => setTicket({ ...ticket, query: e.target.value })} required />

            <div className="mt-3">
            <button type="submit" className="btn" style={{ minWidth: "", border: "1px solid #62BD69" }}>
            {createloading ? "Creating Ticket..." : "Create Ticket"}
              </button>
            </div>
            {message && <p className="message">{message}</p>}
          </form>
        </div>

        {/* Ticket Table Box */}
        <div className="box" style={{width:"100%",padding: "20px", background: "#fff", borderRadius: "8px", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)" }}>
          <h2 style={{color:"#62BD69"}}>All Tickets</h2>
          {loading ? (
            <p>Loading...</p>
          ) : (
           <>
<div className="table-wrapper" style={{ overflowX: "scroll",minWidth:"100%"}}>
  <table className="table">
    <thead>
      <tr>
        <th>Ticket ID</th>
        <th>Category</th>
        <th>Subcategory</th>
        <th>Raised By</th>
        <th>Charges</th>
        <th>Status</th>
        <th>Timestamp</th>
      </tr>
    </thead>
    <tbody>
      {currentTickets.length > 0 ? (
        currentTickets.map((ticket, index) => (
          <tr key={index}>
            <td>{ticket.ticket_id}</td>
            <td>{ticket.ticket_category}</td>
            <td>{ticket.ticket_subcategory}</td>
            <td>{ticket.ticket_raised_by}</td>
            <td>{ticket.charges}</td>
            <td>{ticket.status}</td>
            <td>{new Date(ticket.timestamp).toLocaleString()}</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="6">No tickets found</td>
        </tr>
      )}
    </tbody>
  </table>
</div>

<div className="pagination">
  {[...Array(Math.ceil(tickets.length / ticketsPerPage)).keys()].map((number) => (
    <button key={number + 1} onClick={() => setCurrentPage(number + 1)} className={currentPage === number + 1 ? "active" : ""}>
      {number + 1}
    </button>
  ))}
</div>

           </>
          )}
        </div>
        
        
      </div>
      </div>
    </>
  );
};

export default Ticket;
